import { Alert, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

interface ContextWarningAlertProps {
  missingContextNames: string[];
  sx?: SxProps<Theme>;
}

const ContextWarningAlert = ({ missingContextNames, sx }: ContextWarningAlertProps) => {
  return (
    <Alert severity="warning" sx={{ textAlign: "left", ...sx }}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Unable to load required context data
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Missing: {missingContextNames.join(", ")}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Please try refreshing the page or selecting a different lens.
      </Typography>
    </Alert>
  );
};

export default ContextWarningAlert;
